interface MediaItem {
  image: string;
  title: string;
  duration: string;
  views: string;
  tag: string;
}

const mediaItems: MediaItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20highlight%20clip%20thumbnail%2C%20dramatic%20scene%20with%20two%20characters%20in%20intense%20conversation%2C%20warm%20golden%20lighting%2C%20film%20grain%20texture%2C%20movie%20poster%20style%2C%20rich%20warm%20tones%2C%20cinematic%20composition&width=800&height=450&seq=media-01&orientation=landscape",
    title: '《星落长河》大结局名场面',
    duration: '04:32',
    views: '128万',
    tag: '名场面',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Action%20packed%20martial%20arts%20fight%20scene%20highlight%2C%20dynamic%20combat%20with%20dramatic%20lighting%2C%20epic%20cinematography%2C%20warm%20orange%20and%20amber%20tones%2C%20stylized%20illustration%2C%20movie%20poster%20aesthetic&width=800&height=450&seq=media-02&orientation=landscape",
    title: '《风起云涌》武打集锦',
    duration: '06:15',
    views: '96万',
    tag: '动作戏',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Romantic%20climax%20scene%20from%20Korean%20drama%2C%20emotional%20reunion%20moment%2C%20soft%20warm%20lighting%2C%20beautiful%20cinematography%2C%20stylized%20illustration%2C%20gentle%20color%20palette%2C%20dreamy%20atmosphere&width=800&height=450&seq=media-03&orientation=landscape",
    title: '《月之恋人》心动时刻合集',
    duration: '03:48',
    views: '156万',
    tag: '甜度爆表',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          精彩片段
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">热门剧集高光时刻，精彩不容错过</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="800"
                  height="450"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 text-[10px] font-medium px-2 py-1 rounded bg-background-950/70 text-background-50 whitespace-nowrap">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 text-[10px] font-bold px-2 py-1 rounded bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-2">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-eye-line mr-1"></i>{item.views} 次播放</span>
                  <span><i className="ri-time-line mr-1"></i>{item.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}